import React, { useState, useEffect } from "react";
import "./Slider.css"; // CSS file (niche diya gaya hai)
import BookNow from "./BookNow";
import { BASE_URL } from "../Base_url/Base_Url";
import Loader from "../Base_url/Loader";
import { useGlobalContext } from "../Base_url/GobelContaxt";
import { NavLink } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
function NextArrow({ onClick }) {
    return (
        <button className="nav-arrow next" onClick={onClick}>
            <i className="bi bi-arrow-right"></i>
        </button>
    );
}

function PrevArrow({ onClick }) {
    return (
        <button className="nav-arrow prev" onClick={onClick}>
            <i className="bi bi-arrow-left"></i>
        </button>
    );
}

const Slider = () => {
    const [slides, setSlides] = useState([]);
    const [loading, setloading] = useState(false);
    const { contactData } = useGlobalContext();
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isPaused, setIsPaused] = useState(false);

    // Auto slide every 5 seconds
    useEffect(() => {
        if (isPaused) return;

        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
        }, 2000);

        return () => clearInterval(interval);
    }, [currentSlide, isPaused, slides.length]);

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
    };

    const goToSlide = (index) => {
        setCurrentSlide(index);
    };

    // '''''''''


    useEffect(() => {
        setloading(true);
        const fetchSlides = async () => {
            try {
                const response = await fetch(`${BASE_URL}/slider/`);
                const result = await response.json();

                if (response.ok && result?.data?.length > 0) {
                    setSlides(result.data);
                }
            } catch (error) {
                console.error("Error fetching slider data:", error);
            }
            finally {
                setloading(false);

            }
        };

        fetchSlides();
    }, []);

    console.log("slides", slides)
    const settings = {
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 800,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        arrows: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        appendDots: dots => (
            <div className="custom-dots">
                <ul>{dots}</ul>
            </div>
        ),
    };

    return (
        <section
            className="hero"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
        >
            {/* Slider Images */}
            <div className="slider-wrapper">
                {slides.map((slide, index) => (
                    <div
                        key={slide.id}
                        className={`slide ${index === currentSlide ? "active" : ""}`}
                        style={{
                            backgroundImage: slide?.Slider_image1
                                ? `url(${BASE_URL}${slide.Slider_image1})`
                                : "url('/fallback.jpg')", // fallback image dal de
                        }}
                    ></div>
                ))}
            </div>


            {/* Overlay Content (Text + CTA) */}
            <div className="container hero-content">
                <div className="hero-text">
                    <p className="fw-bold text-warning">{slides[currentSlide]?.Slider_topline || "Loading..."}</p>
                    <h3>{slides[currentSlide]?.Slider_maintext || ""}</h3>
                    <p>{slides[currentSlide]?.Slider_lastline || ""}</p>
                    {/* <p className="mb-5 fs-5"> {Slider.}</p> */}


                    {/* <a href="/services" className="btn"> 
                        Explore Services
                    </a> */}
                    <div className="slider-btn-group">
                        {/* Call Button */}
                        <a
                            className="slider-btn"
                            href={`tel:${slides?.Slider_button_link}`}
                        >
                            <i className="bi bi-telephone-fill"></i> {slides?.Slider_button_text || "Call Now"}
                        </a>

                        {/* WhatsApp Button */}
                        <a
                            className="slider-btn whatsapp-btn"
                            href={`https://wa.me/9116839808?text=Hi${slides?.Slider_button_link}?text=Hi, I am interested in your services.`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaWhatsapp size={20} /> WhatsApp                        </a>
                    </div>


                </div>

                {/* '''''''''''''''''''''''' */}
                <BookNow />


                {/* Booking Form (Right Side with Hover Effect) */}
                {/* <div className="booking-form-wrapper">
                    <div className="booking-form">
                        <h3>Book Your Ride</h3>
                        <form>
                            <div className="form-group">
                                <label htmlFor="pickup">Pickup Location</label>
                                <input
                                    type="text"
                                    id="pickup"
                                    className="form-control"
                                    placeholder="Enter pickup location"
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="dropoff">Drop Location</label>
                                <input
                                    type="text"
                                    id="dropoff"
                                    className="form-control"
                                    placeholder="Enter drop location"
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="date">Date</label>
                                <input type="date" id="date" className="form-control" required />
                            </div>

                            <div className="form-group">
                                <label htmlFor="time">Time</label>
                                <input type="time" id="time" className="form-control" required />
                            </div>

                            <div className="form-group">
                                <label htmlFor="vehicle">Vehicle Type</label>
                                <select id="vehicle" className="form-control" required>
                                    <option value="">Select Vehicle Type</option>
                                    <option value="sedan">Sedan</option>
                                    <option value="suv">SUV</option>
                                    <option value="luxury">Luxury</option>
                                    <option value="tempo">Tempo Traveller</option>
                                    <option value="bus">Bus</option>
                                </select>
                            </div>

                            <button type="submit" className="btn" style={{ width: "100%" }}>
                                Book Now
                            </button>
                        </form>
                    </div>
                </div> */}
            </div>

            {/* Navigation Dots */}
            <div className="slider-dots">
                {slides.map((_, index) => (
                    <span
                        key={index}
                        className={`dot ${index === currentSlide ? "active" : ""}`}
                        onClick={() => goToSlide(index)}
                    ></span>
                ))}
            </div>

            {/* Navigation Arrows */}
            <button className="nav-btn prev" onClick={prevSlide}>
                &#10094;
            </button>
            <button className="nav-btn next" onClick={nextSlide}>
                &#10095;
            </button>
            <div class="curve">
                <svg viewBox="0 0 500 150" preserveAspectRatio="none">
                    <path d="M0,80 C150,200 350,-60 500,80 L500,150 L0,150 Z"></path>
                </svg>
            </div>
        </section>
    );
};

export default Slider;